import React from 'react';
import { Box, Dialog, Link, styled, Text } from 'bumbag';

import Toggled from '@medipass/react-core/Forms/components/Toggled';
const Wrapper = styled(Box)`
  display: flex;
  align-items: center;
  line-height: 1.2em;
`;
export interface Props {
  className: string | null | undefined;
}

export default function ApprovedDelcaration({ className }: Props) {
  return (
    <Toggled>
      {({
        getElementTogglerProps,
        on,
        setOn,
        setOff,
      }: {
        on: boolean;
        setOn: () => void;
        setOff: () => void;
        getElementTogglerProps: () => any;
      }) => (
        // @ts-expect-error TS(2322): Type 'string | null | undefined' is not assignable... Remove this comment to see the full error message
        <Wrapper className={className}>
          <Dialog.Modal
            baseId="approved-declaration"
            visible={on}
            hide={setOff}
            title="Important declaration"
            showCloseButton
          >
            <Box>
              I declare that the service/s shown on this claim have been provided to the person/s listed above, are not
              subject to Medicare reimbursement or any other form of compensation, and do not knowingly breach fund
              rules. I authorise the fund to pay benefit/s directly to the provider and to verify any aspect of this
              claim including through provision of treatment records.
            </Box>
          </Dialog.Modal>
          <Text fontSize="100" fontWeight="semibold">
            By approving this transaction, you certify the above services have been provided subject to this{' '}
            <Link {...getElementTogglerProps()} onClick={setOn}>
              IMPORTANT DECLARATION
            </Link>
          </Text>
        </Wrapper>
      )}
    </Toggled>
  );
}
